export const WHATSAPP = "5544991036442";
export const WHATSAPP_DISPLAY = "(44) 99103-6442";

export const LEGAL = {
  razaoSocial: "ZARI ENGENHARIA E SOLUCOES LTDA",
  cnpj: "59.148.532/0001-13",
  email: "eng.gabrielzari@gmail.com",
  instagram: "https://www.instagram.com/zariengenharia/",
  instagramHandle: "@zariengenharia",
  address: "Rua José Tondato, 16, Centro — Terra Roxa — PR, 85990-000",
  city: "Terra Roxa — PR",
  phone: WHATSAPP_DISPLAY,
};

export const waLink = (text) =>
  `https://wa.me/${WHATSAPP}?text=${encodeURIComponent(text)}`;

export const scrollToId = (hash) => {
  if (window.__lenis) {
    window.__lenis.scrollTo(hash, { offset: -72, duration: 1.4 });
  } else {
    document.querySelector(hash)?.scrollIntoView();
  }
};
